import { Button, FlexRow } from '@epam/loveship'
import {
  CategoryResponse,
  ExtendedPoint,
  PointResponse,
} from '../../../../../../constants/types'
import { useAppSelector } from '../../../../../../hooks/redux/redux'
import { PointCard } from '../PointCard/PointCard'
import { useGetLayersQuery } from '../../../../../../store'
import { useArePointsShownFirstTime } from '../../../../../../hooks/useIsFirstPointsList'
import css from './PointList.module.scss'
import { useSideBarControlls } from '../../../../../../hooks/useSideBarControlls'

interface PointListProps {
  points: PointResponse[]
  categories: CategoryResponse[] | undefined
}

export const PointList: React.FC<PointListProps> = ({ points, categories }) => {
  const arePointsShownFirstTime = useArePointsShownFirstTime()
  const { showCreateNewPoint, showPointInfo } = useSideBarControlls()
  const { selectedLayers } = useAppSelector((state) => state.layers)
  const { data: layers = [] } = useGetLayersQuery()
  const extendedPoints: ExtendedPoint[] = points.map((point) => {
    const currentLayer = layers.find((layer) => layer.id === point.layerId)
    return {
      ...point,
      iconId: currentLayer?.parentId || 0,
      layerName: currentLayer?.name || 'n/a',
    }
  })

  return (
    <>
      <FlexRow padding="24">
        <Button
          cx={css.toggleBtn}
          fill="white"
          color="sky"
          caption="+ Create place"
          onClick={showCreateNewPoint}
        />
      </FlexRow>
      {extendedPoints
        .filter(
          (point) =>
            arePointsShownFirstTime || selectedLayers.includes(point.layerId)
        )
        .map((point: any) => (
          <PointCard key={point.id} point={point} />
        ))}
    </>
  )
}
